// internal
import { axios, def, storage, handleError, handleResponse } from './internal';
import { debounceSettle } from '../request-control/debounce';

// `comment` is the comment as shown ({ _id, liked, likeCount }); `onChange(liked, likeCount)` updates the screen. The
// screen changes at once and the wanted state is sent through the debounce (see request-control/debounce.js), only when
// the user ended on the other state. The server applies it asynchronously and returns no count, so the new count is
// derived here from the state the user saw.
function CommentLike(comment, onChange) {
    const id = comment._id;
    const url = `/api/comments/${encodeURIComponent(id)}/like`;

    // A browsing guest cannot like: send at once so the guest gate (app.jsx) asks for login, with no optimistic flip.
    if (!storage.transience.getValue().user) {
        axios.put(url, { liked: !comment.liked }).catch(handleError);
        return;
    }

    const liked = !comment.liked;
    onChange(liked, Math.max(0, (comment.likeCount ?? 0) + (liked ? 1 : -1)));

    debounceSettle(`comment-like:${id}`, {
        base: !!comment.liked,
        want: liked,
        send: (want, options) =>
            axios
                .put(url, { liked: want }, options)
                .then((res) => {
                    if (res.data.code === def.ErrorCode.OK) return true;
                    handleResponse(res);
                    return false;
                })
                .catch((err) => {
                    handleError(err);
                    return false;
                }),
        revert: () => onChange(!!comment.liked, comment.likeCount ?? 0),
    });
}

export { CommentLike };
